import * as actionTypes from './action-types';

const initialState = {
    authorized: null,
    displayModalStatus: false
};

const checkAuthorizationSucceed = (state, authorized) => ({ ...state, authorized, displayModalStatus: !authorized });

const checkAuthorizationFailed = state => ({ ...state, authorized: false, displayModalStatus: true });

const setDisplayAlertModalStatus = (state, displayModalStatus) => ({ ...state, displayModalStatus });

const reducer = (state = initialState, action) => {
    switch (action.type) {
    case actionTypes.CHECK_USER_IS_AUTHORIZED_SUCCEED:
        return checkAuthorizationSucceed(state, action.payload);
    case actionTypes.CHECK_USER_IS_AUTHORIZED_FAILURE:
        return checkAuthorizationFailed(state);
    case actionTypes.ALERT_MODAL_DISPLAY_STATUS:
        return setDisplayAlertModalStatus(state, action.displayModalStatus);
    default:
        return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./app/components/with-auth/reducer.js